"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IfAllowed_1 = require("./IfAllowed");

exports.IfAllowed = IfAllowed_1.IfAllowed;

var isAllowed_1 = require("./isAllowed");

exports.isAllowed = isAllowed_1.isAllowed;

var IfAllowedRoles_1 = require("./IfAllowedRoles");

exports.IfAllowedRoles = IfAllowedRoles_1.IfAllowedRoles;

var useAllowedRoles_1 = require("./useAllowedRoles");

exports.useAllowedRoles = useAllowedRoles_1.useAllowedRoles;

var PermissionsContext_1 = require("./PermissionsContext");

exports.PermissionsContext = PermissionsContext_1.PermissionsContext;

var PermissionsProvider_1 = require("./PermissionsProvider");

exports.PermissionsProvider = PermissionsProvider_1.PermissionsProvider;

var withPermissions_1 = require("./withPermissions");

exports.withPermissions = withPermissions_1.withPermissions;

var usePermissions_1 = require("./usePermissions");

exports.usePermissions = usePermissions_1.usePermissions;